import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import AppAppBar from "../homePage/AppAppBar";
import Hero from "../homePage/Hero";
import Highlights from "../homePage/Highlights";
import Features from "../homePage/Features";
import Testimonials from "../homePage/Testimonials";
import Footer from "../homePage/Footer";
import HomeDocument from "../homePage/HomeDocument";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function HomePage() {
  const [showScroll, setShowScroll] = useState(false);

  // Function to handle scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Function to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 2000) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <AppAppBar />
      <Hero />
      <Box sx={{ bgcolor: "background.default" }}>
        <Divider />
        <Testimonials />
        <Divider />
        <Highlights />
        <Divider />
        <Features />
        <Divider />
        <HomeDocument />
        <Divider />
        <Footer />
      </Box>

      {/* Scroll to Top Button */}
      {showScroll && (
        <Button
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            bgcolor: "primary.light",
            color: "white",
            borderRadius: "50%",
            minWidth: 40,
            minHeight: 40,
            padding: 0,
            display: "flex", // Use flexbox
            justifyContent: "center", // Horizontally center the icon
            alignItems: "center", // Vertically center the icon
            "&:hover": {
              bgcolor: "primary.dark",
            },
          }}
          variant="contained"
        >
          <KeyboardArrowUpIcon />
        </Button>
      )}
    </>
  );
}
